import { Button, Card, MonoLabel } from '@/design-system';
import type { DashboardSignal } from '@/entities/order';

import { dashboardCopy } from '../copy';

export interface SignalCardProps {
    signals: readonly DashboardSignal[];
    onFollow: (signal: DashboardSignal) => void;
}

/**
 * De donkere kaart rechtsonder: de belangrijkste waarnemingen, elk met één
 * knop die er iets mee doet. Zonder signaal blijft de kaart leeg maar eerlijk.
 */
export function SignalCard({ signals, onFollow }: SignalCardProps) {
    return (
        <Card variant="dark" padding="md">
            <MonoLabel size={10} tone="onDarkMuted" as="div" className="mb-[10px] tracking-[0.1em]">
                {dashboardCopy.signalEyebrow}
            </MonoLabel>

            {signals.length === 0 ? (
                <p className="m-0 text-[14px] leading-[1.5] text-[var(--text-on-dark-2)]">
                    {dashboardCopy.signalEmpty}
                </p>
            ) : (
                <ul className="m-0 grid list-none gap-[18px] p-0">
                    {signals.map((signal) => (
                        <li key={signal.key}>
                            <p className="m-0 text-[14px] leading-[1.5] text-[var(--text-on-dark-soft)]">
                                {signal.body}
                            </p>
                            <Button
                                variant="onDark"
                                size="sm"
                                className="mt-[10px] text-[var(--text-on-dark)]"
                                onClick={() => onFollow(signal)}
                            >
                                {signal.actionLabel}
                            </Button>
                        </li>
                    ))}
                </ul>
            )}
        </Card>
    );
}
